/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { SetGlobalStyle } from "@nordcloud/gnui";
import { App } from "~/App";
import { GNUIThemeProvider } from "~/hooks/useGNUITheme";
import { AuthWall, Auth0ProviderWithHistory, auth0Client } from "~/services";
import { Apollo, CustomerSelector } from "./context";
import "react-toastify/dist/ReactToastify.css";
import "./setupDayjs";

const container = document.getElementById("root");
if (!container) {
  throw new Error("The element #root wasn't found");
}

const root = createRoot(container);

root.render(
  <Router>
    <Auth0ProviderWithHistory client={auth0Client}>
      <AuthWall>
        <SetGlobalStyle customScrollbars />
        <Apollo>
          <CustomerSelector>
            <GNUIThemeProvider>
              <App />
            </GNUIThemeProvider>
          </CustomerSelector>
        </Apollo>
      </AuthWall>
    </Auth0ProviderWithHistory>
  </Router>
);
